export default __webpack_public_path__ + "static/assets/482f184ef69aff698840d5baf47bcfe1.png";